import {useEffect} from "react" // 30 Nov 2025
import { Routes, Route } from "react-router-dom"

import EtWeb from '@/pages/landing/EtWeb'
import EtHome from '@/pages/landing/EtHome'
import EtEternityHome from '@/pages/landing/EtEternityHome'
import EtTrinityHome from '@/pages/landing/EtTrinityHome'
import EtUserWaitList from "@/pages/admin/userWaitLists/EtUserWaitList";
import Login from '@/features/auth/Login'
import SignUpNewUserForm from '@/features/users/SignUpNewUserForm'
import PersistLogin from "@/features/auth/PersistLogin"
import RequireAuth from "@/features/auth/RequireAuth"
import { ROLES } from "@/config/role" 
import Prefetch from "@/features/auth/Prefetch"
import EtClients from "@/pages/landing/EtClients"
import EtInvestors from "@/pages/landing/EtInvestors"

// 15 Oct 2025
import EtUserGrowthSparkRequests from "@/pages/admin/userGrowthSparkRequests/EtUserGrowthSparkRequests"
import EtTrinityPlatform from "@/pages/trinity/EtTrinityPlatform"

// 20 Nov 2025
import EtThinkWare from "@/pages/landing/EtThinkWare"

// 22 Nov 2025
import EtAbout from "@/pages/landing/EtAbout"
import EtPrivacy from "@/pages/landing/EtPrivacy"
import EtTerms from "@/pages/landing/EtTerms"
import EtFAQ from "@/pages/landing/EtFAQ"

// 29 Nov 2025
import EtWebAdmin from "@/pages/admin/webAdmin/EtWebAdmin"

// 01 Dec 2025
import useAuth from "@/hooks/useAuth";

const App = () => {
  // First Created - 27 Mar 2025
  // Author - Atul Pandey
  // Inherited from Corey Marsh's original etlanding252 project and subsequently modified by Atul
  // Updated - 28 Mar 2025 - adjustment for screen sizes
  // Updated - 31 Mar 2025 - moved the main landing page code to EtWeb
  // Updated - 31 Mar 2025 - added Routes and Route
  // Updated - 31 Mar 2025 - added Public and Protected Routes
  // Updated - 31 Mar 2025 - added Admin User Login
  // Updated - 15 Oct 2025 - added webleads path for userGrowthSparkRequests
  // Updated - 20 Nov 2025 - added thinkware
  // Updated - 22 Nov 2025 - added about
  // Updated - 29 Nov 2025 - added EtWebAdmin
  // Updated - 30 Nov 2025 - added protection from copying content from the website
  // Updated - 01 Dec 2025 - refined protection for et admin users

  // 1a - Role based protection - 01 Dec 2025
  const { roles } = useAuth();
  console.log('roles', roles)
  
  // 1b - Copy protection - 30 Nov 2025
  useEffect(() => {
    if (roles?.includes("EtAdmin")) {
      document.body.classList.add("allow-copy");
    } else {
      document.body.classList.remove("allow-copy");
    }
  }, [roles]);

  useEffect(() => {
    if (roles?.includes("EtAdmin")) return; // <-- SKIP for admins - 01 Dec 2025

    // Disable right-click
    document.addEventListener("contextmenu", (e) => e.preventDefault());

    // Disable keyboard shortcuts
    document.addEventListener("keydown", (e) => {
      if (
        (e.ctrlKey || e.metaKey) &&
        ["c", "x", "v", "a", "s"].includes(e.key.toLowerCase())
      ) {
        e.preventDefault();
      }
    });

    // Disable drag events
    document.addEventListener("dragstart", (e) => e.preventDefault());
  }, []);

  return (
    <Routes>
      <Route path="/">

        {/* Public Routes */}
          {/* <Route index element={<EtWeb />} /> */}
          {/* <Route index element={<EtHome />} /> */}
          <Route index element={<EtEternityHome />} />
          <Route path="clients" element={<EtClients />} />
          <Route path="investors" element={<EtInvestors />} />
          <Route path="thinkware" element={<EtThinkWare />} />
          <Route path="about" element={<EtAbout />} />
          <Route path="privacy" element={<EtPrivacy />} />
          <Route path="terms" element={<EtTerms />} />
          <Route path="faq" element={<EtFAQ />} />
          
          {/* <Route path="trinity" element={<EtTrinityHome />} /> */}
          <Route path="trinity" >

              <Route index element={<EtTrinityPlatform />} />
              <Route path="platform" element={<EtTrinityPlatform />} />
              <Route path="meet" element={<EtTrinityHome />} />

          </Route>

          <Route path="login" element={<Login />} />
           <Route path="signup" element={<SignUpNewUserForm />} />
           {/* <Route path="userWaitList" element={<EtUserWaitList />} /> */}
          

        {/* Protected Routes */}
        <Route element={<PersistLogin />}>
            <Route
              element={<RequireAuth allowedRoles={[...Object.values(ROLES)]} />}
            >
              <Route element={<Prefetch />}>
              
                    <Route path="userWaitList" element={<EtUserWaitList />} />
                    <Route path="webleads" element={<EtUserGrowthSparkRequests />} /> {/* 15 Oct 2025 */}
                    <Route path="admin" element={<EtWebAdmin />} /> {/* 29 Nov 2025 */}
                    

              
              </Route> {/* End of Protected routes  - prefetch */}

            </Route>{/* End of Protected routes  - require auth*/}
        </Route>{/* End of Protected routes - persist login*/}
      </Route>
    </Routes>
  );
}

export default App